import { ChevronRight } from 'lucide-react'
import { Fragment } from 'react'
import { cn } from '../cn'
import { UiLink } from '../link'

export interface BreadcrumbItem {
  label: string
  /** Omit on the current page. */
  href?: string
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[]
  className?: string
}

/** NAV-006 breadcrumb trail. The last item is the current page (`aria-current="page"`). */
export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn('text-[13px]', className)}>
      <ol className="flex flex-wrap items-center gap-1.5 text-sage">
        {items.map((item, index) => {
          const last = index === items.length - 1
          return (
            // biome-ignore lint/suspicious/noArrayIndexKey: a trail is static and labels may repeat
            <Fragment key={`${item.label}-${index}`}>
              <li className="min-w-0">
                {item.href && !last ? (
                  <UiLink
                    href={item.href}
                    className="font-medium text-teal underline-offset-4 hover:underline"
                  >
                    {item.label}
                  </UiLink>
                ) : (
                  <span aria-current={last ? 'page' : undefined} className="text-ink-soft">
                    {item.label}
                  </span>
                )}
              </li>
              {!last ? (
                <li aria-hidden="true" className="text-line-strong">
                  <ChevronRight className="size-3.5" />
                </li>
              ) : null}
            </Fragment>
          )
        })}
      </ol>
    </nav>
  )
}
